import { CriterioCustom } from '../criterio-custom';
import { SearchAdempimentiRequest } from '../dto/adempimenti-search';
import { SearchRequest } from '../dto/search-request';
import { SearchResponse } from '../dto/search-response';
import { MiaRicerca } from '../mia-ricerca';
import { MioCriterio } from '../mio-criterio';
import { ComboBean } from './combo-bean';
import { ListaCriteriBean } from './lista-criteri-bean';
import { ParametriCriteriBean } from './parametri-criteri-bean';
import { ParametroCriteriBean } from './parametro-criteri-bean';

export class RicercaBean {
  searchRequest: SearchRequest;
  searchRequestReload: SearchRequest;
  searchAdempimentiRequest: SearchAdempimentiRequest;
  searchResponse: SearchResponse;
  numAdempimentiPubbliciTrovati: number;
  numAdempimentiPrivatiTrovati: number;
  // Variabile utilizzata per la visualizzazione dei risultati della ricerca pratica
  resultPratica: boolean;
  // Variabile utilizzata per la visualizzazione dei risultati della ricerca documento
  resultDocumento: boolean;
  openContainer: boolean;
  enableContainerInteraction: boolean;
  criteriCustom: CriterioCustom[];
  listaCriteriBean: ListaCriteriBean;
  criteriUtente: CriterioCustom[];
  listaTemplates: MiaRicerca[];
  listaEstrazioniTemplates: MiaRicerca[];
  listaCriteriTemplate: MioCriterio[];
  listaCriteriUtente: ParametroCriteriBean[];
  listaElementiCombo: ComboBean[];
  numberCriteriRows: ParametriCriteriBean[];
  ricercaForm: any;
  listOfDates: Array<string>;
  onSearch: boolean;
  listToggleOpened: Array<number>;
  scrollDisabled: boolean;
  actionOrdinamento: string;
  ricercaAggregata?: boolean;

  constructor() {
    this.searchRequest = new SearchRequest();
    this.searchRequestReload = new SearchRequest();
    this.searchResponse = new SearchResponse();
    this.resultPratica = false;
    this.resultDocumento = false;
    this.openContainer = true;
    this.enableContainerInteraction = false;
    this.criteriCustom = new Array<CriterioCustom>();
    this.listOfDates = new Array<string>();
    this.listToggleOpened = new Array<number>();
    this.scrollDisabled = false;
  };

}
